import { takeLatest, put, select, call } from 'redux-saga/effects';

import quoteItemService from 'modules/quotes/quoteItems/data/service';
import { UPDATE_COMPONENT_SUCCESS } from 'modules/quotes/quoteItems/data/types';

import { types } from './actions';
import { liveAddOnPreview } from './actions';
import {
  getAddOnId,
  getCurrentOverrides,
  getIsAddOnModalOpen,
} from './reducer';

export default function* root() {
  yield takeLatest(types.OPEN_ADD_ON_MODAL, watchOpenAddOnModal);
  yield takeLatest(
    types.LIVE_ADD_ON_PREVIEW_REQUEST,
    watchLiveAddOnPreviewRequest,
  );
  yield takeLatest(UPDATE_COMPONENT_SUCCESS, watchUpdateComponentSuccess);
  yield takeLatest(types.RECEIVE_OVERRIDES, watchReceiveOverrides);
}

function* watchOpenAddOnModal(action) {
  const { payload } = action;
  const { addOn } = payload;
  yield put(
    liveAddOnPreview.request({
      addOnId: addOn.id,
      newOverrides: addOn.overrides,
    }),
  );
}

function* watchUpdateComponentSuccess() {
  const addOnId = yield select(getAddOnId);
  const overrides = yield select(getCurrentOverrides);
  const isOpen = yield select(getIsAddOnModalOpen);
  if (isOpen) {
    yield put(
      liveAddOnPreview.request({ addOnId: addOnId, newOverrides: overrides }),
    );
  }
}

function* watchLiveAddOnPreviewRequest(action) {
  try {
    const { payload } = action;
    const { addOnId, overrides } = payload;
    const response = yield call(quoteItemService.addOns.livePricing, addOnId, {
      overrides,
    });
    yield put(liveAddOnPreview.success(response));
  } catch (error) {
    console.error(error);
    yield put(liveAddOnPreview.error);
  }
}

function* watchReceiveOverrides(action) {
  const { payload } = action;
  const { nextOverrides } = payload;
  const addOnId = yield select(getAddOnId);
  yield put(
    liveAddOnPreview.request({ addOnId: addOnId, newOverrides: nextOverrides }),
  );
}
